/** Eladói alapértelmezett kiegészítők — minden új hirdetésre (kikapcsolható autónként). */
export const LISTING_DEFAULT_ADDON_ONE_TIME = [
  "viewer_360",
  "ai_photo_bg",
  "ai_customer_support",
  "facebook_crosspost",
];

export const LISTING_DEFAULT_ADDON_WEEKLY = [
  "list_boost",
  "priority_ranking",
  "meta_ads",
];

export const ALL_LISTING_DEFAULT_ADDON_KEYS = [
  ...LISTING_DEFAULT_ADDON_ONE_TIME,
  ...LISTING_DEFAULT_ADDON_WEEKLY,
];

export function sanitizeListingAddonKeys(keys) {
  if (!Array.isArray(keys)) return [];
  const allowed = new Set(ALL_LISTING_DEFAULT_ADDON_KEYS);
  const out = [];
  const seen = new Set();
  for (const raw of keys) {
    const k = String(raw || "").trim();
    if (!allowed.has(k) || seen.has(k)) continue;
    seen.add(k);
    out.push(k);
  }
  return out;
}

export function splitDefaultListingAddons(keys) {
  const list = sanitizeListingAddonKeys(keys);
  return {
    oneTime: list.filter((k) => LISTING_DEFAULT_ADDON_ONE_TIME.includes(k)),
    weekly: list.filter((k) => LISTING_DEFAULT_ADDON_WEEKLY.includes(k)),
  };
}
